export default "__VITE_ASSET__e6d76c41__"